import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9e4344b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header flex-bwn-ter mb_2" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = {
  key: 0,
  class: "vip_logo",
  src: "https://static-s.theckb.com/BusinessMarket/member/new_logo.png",
  alt: ""
}
const _hoisted_4 = { class: "time" }
const _hoisted_5 = { class: "list flex" }

import { computed } from 'vue'
import { QueryShareLinkListRespVO } from '@/service/goods'
import { useRtfix } from '@/store'
import { useRouter } from 'vue-router'

export default /*#__PURE__*/_defineComponent({
  props: {
    choice: { type: null, required: true },
    max: { type: Number, required: true },
    showNew: { type: Boolean, required: false }
  },
  setup(__props: any) {

const props = __props as {
  choice: QueryShareLinkListRespVO,
  max: number,
  showNew?: boolean
}
const router = useRouter()


const jump = (item: { shareCode: string }) => {
  router.push(useRtfix('ckbChoice', { params: { code: item.shareCode } }))
}

const showList = computed(() => {
  return (props.choice?.headerImages?.length ?? 0) >= props.max ? props.choice?.headerImages?.slice(0, props.max) : props.choice?.headerImages
})

const flexStyle = computed(() => {
  return (props.choice?.headerImages?.length ?? 0) >= props.max ? 'space-between' : 'flex-start'
})
console.log(props, 'props', flexStyle.value)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "container",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (jump(props.choice as any)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (__props.showNew)
          ? (_openBlock(), _createElementBlock("img", _hoisted_3))
          : _createCommentVNode("", true),
        _createTextVNode(" " + _toDisplayString(__props.choice?.title), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", null, _toDisplayString(__props.choice?.createTime?.slice(0, 10)), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(showList), (img, idx) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "item",
          key: idx,
          style: _normalizeStyle(`background-image: url(${img});`)
        }, null, 4))
      }), 128))
    ])
  ]))
}
}

})